import { SyncStatusView } from './models'
import React from 'react'

export const ExternalUpdateTitle: React.FC<{ syncStatus: SyncStatusView }> = ({ syncStatus }) => {
  const getSyncStatusTypeName = (syncStatus: SyncStatusView): string => {
    const groupLength = (syncStatus.groups?.length || 0) + 1
    const isGrouped = (syncStatus.groups?.length || 0) > 0
    switch (syncStatus.type) {
      case 'export':
        return !isGrouped ? 'Meeting' : `${groupLength} Meetings`
      case 'meetingSummary':
        return !isGrouped ? 'Meeting summary' : `${groupLength} Meeting summaries`
      case 'aiResult':
        return syncStatus.name || `${groupLength} AI result`
      case 'task':
        return !isGrouped ? 'task' : `${groupLength} tasks`
      default:
        return 'data'
    }
  }

  const getExportTitle = (syncStatus: SyncStatusView) => {
    switch (syncStatus.type) {
      case 'export':
        return (
          <div>
            <b>{getSyncStatusTypeName(syncStatus)}</b> exported to <span className='text-capitalize'>{syncStatus.serviceId}</span>
          </div>
        )
      case 'meetingSummary':
        return (
          <div>
            Saved <b>{getSyncStatusTypeName(syncStatus)}</b> to <span className='text-capitalize'>{syncStatus.serviceId}</span>
          </div>
        )
      case 'aiResult':
        return (
          <div>
            Saved <b>{getSyncStatusTypeName(syncStatus)}</b> to <span className='text-capitalize'>{syncStatus.serviceId}</span>
          </div>
        )
      case 'task':
        return (
          <div>
            Saved <b>{getSyncStatusTypeName(syncStatus)}</b> to <span className='text-capitalize'>{syncStatus.serviceId}</span>
          </div>
        )
    }
  }

  return <div>{getExportTitle(syncStatus)}</div>
}
